export const sortByPriority = (arr: any[]) => {
  return [...arr].sort((a, b) => (a.priority > b.priority ? 1 : -1));
};
